module.exports = __webpack_public_path__ + "static/img/Scott_Pendlebury_desktop.c4eb482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Scott_Pendlebury_desktop.jpg
// module id = FF5F
// module chunks = 0